import React from "react"
import { Block, BlockRow } from "./Block"
import { Overlay } from "./Overlay"

interface InfoDialogProps {
  message: React.ReactNode;
  onClose: () => void;
  style?: string;
  title?: string;
}

// Simple information dialog that displays text from yaml localization files.
// Shows an overlay with the message and a close X button on the top right.
// No other functions - just information display for the user.
//
// Usage example:
// const [showInfo, setShowInfo] = useState(false);
// const mt = app.getM("MyComponent"); // Get message accessor for yaml
//
// {showInfo && (
//   <InfoDialog
//     title={t("info_title")}
//     message={mt("info_message")} // Get message from yaml
//     onClose={() => setShowInfo(false)}
//     style="info"
//   />
// )}
export function InfoDialog({ message, onClose, style, title }: InfoDialogProps) {
  return (
    <Overlay className="InfoDialog InfoDialog-scrollable" closeBackground={true} closeCallback={onClose} style={style || "info"} title={title}>
      <div className="Overlay-body InfoDialog-body">
        <Block>
          <BlockRow className="message-text-bigger">{message}</BlockRow>
        </Block>
      </div>
    </Overlay>
  );
}
